import { render, staticRenderFns } from "./ChooseProductInput.vue?vue&type=template&id=998a1f5e&scoped=true"
import script from "./ChooseProductInput.vue?vue&type=script&lang=js"
export * from "./ChooseProductInput.vue?vue&type=script&lang=js"
import style0 from "./ChooseProductInput.vue?vue&type=style&index=0&id=998a1f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998a1f5e",
  null
  
)

export default component.exports